import script from "./PostPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./PostPreview.vue?vue&type=script&setup=true&lang=js"

import "./PostPreview.vue?vue&type=style&index=0&id=7b90b146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b90b146"]])

export default __exports__